import React, { useState } from 'react';

function ChatAgent() {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const [userMessage, setUserMessage] = useState('');
  const [agi, setAgi] = useState('');
  const [participant, setParticipant] = useState('');
  const [filingStatus, setFilingStatus] = useState('');
  const [spouseParticipant, setSpouseParticipant] = useState('');
  const [marginalRate, setMarginalRate] = useState('');
  const [chatReply, setChatReply] = useState('');

  // async function handleAnalyze() {
  //   setLoading(true);
  //   setError('');
  //   setSummary(null);
  //   setExplanation('');

  //   try {
  //     const res = await fetch('http://localhost:8888/api/financialanalysis', {
  //       method: 'POST',
  //     });

  //     if (!res.ok) {
  //       const text = await res.text();
  //       throw new Error(text || `HTTP ${res.status}`);
  //     }

  //     const data = await res.json();
  //     // Expecting shape: { summary: {...}, explanation: "..." }
  //     setSummary(data.summary || null);
  //     setExplanation(data.explanation || '');
  //   } catch (err) {
  //     console.error(err);
  //     setError('Something went wrong while analyzing your finances.');
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  async function handleChatSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    setChatReply('');

    try {
      const summaryPayload = {
        adjusted_gross_income: agi,
        participates_in_employer_plan: participant,
        filing_status: filingStatus,
        spouse_participates_in_employer_plan: spouseParticipant,
        marginal_federal_tax_rate: marginalRate,
        tax_year: 2024,
        age: 35,
        full_time_student: 'no',
        can_be_claimed_as_dependent: 'no',
      };

      const res = await fetch('/api/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: userMessage,
          kb: 'irs',
          summary: summaryPayload,
        }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `HTTP ${res.status}`);
      }

      const data = await res.json();
      setChatReply(data.reply || 'No reply received.');
    } catch (err) {
      console.error(err);
      setError('Something went wrong while interacting with the chatbot.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: 16 }}>
      {/* <h2>Financial Insights Assistant</h2> */}

      {/* onClick={handleAnalyze}
        disabled={loading}
        style={{
          padding: '8px 16px',
          borderRadius: 8,
          border: '1px solid #333',
          cursor: loading ? 'default' : 'pointer',
          marginBottom: 16,
        }}
      ></div>   <button
   
        {loading ? 'Analyzing...' : 'Analyze my finances'}
      </button> */}

      {/* {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}

      {summary && (
        <div
          style={{
            border: '1px solid #ddd',
            borderRadius: 8,
            padding: 12,
            marginBottom: 16,
            background: '#fafafa',
          }}
        >
          <h3>Summary (raw numbers)</h3>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              fontSize: 13,
            }}
          >
            {JSON.stringify(summary, null, 2)}
          </pre>
        </div>
      )}

      {explanation && (
        <div
          style={{
            border: '1px solid #ddd',
            borderRadius: 8,
            padding: 12,
            background: '#f5f5ff',
          }}
        >
          <h3>AI Explanation</h3>
          <p style={{ whiteSpace: 'pre-wrap' }}>{explanation}</p>
        </div>
      )} */}

      <form onSubmit={handleChatSubmit} style={{ marginTop: 24 }}>
        <h3>
          Check to see how much your client could save for contributing to a
          Traditional or Roth IRA
        </h3>
        <label style={{ display: 'block', marginBottom: 4 }}>
          Adjusted Gross Income
        </label>
        <input
          type="text"
          value={agi}
          onChange={(e) => setAgi(e.target.value)}
          placeholder="Enter your adjusted gross income"
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: 8,
            border: '1px solid #ddd',
            marginBottom: 16,
          }}
        />

        <label style={{ display: 'block', marginBottom: 4 }}>
          Do you participate in a retirement plan offered by your employer?
        </label>
        <select
          value={participant}
          onChange={(e) => setParticipant(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: 8,
            border: '1px solid #ddd',
            marginBottom: 16,
          }}
        >
          <option value="">Select yes or no</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
        </select>

        <label style={{ display: 'block', marginBottom: 4 }}>
          Filing Status
        </label>
        <select
          value={filingStatus}
          onChange={(e) => setFilingStatus(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: 8,
            border: '1px solid #ddd',
            marginBottom: 16,
          }}
        >
          <option value="">Select filing status</option>
          <option value="single">Single</option>
          <option value="married_filing_jointly">Married Filing Jointly</option>
          <option value="head_of_household">Head of Household</option>
        </select>

        <label style={{ display: 'block', marginBottom: 4 }}>
          Does your spouse participate in a retirement plan at work?
        </label>
        <select
          value={spouseParticipant}
          onChange={(e) => setSpouseParticipant(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: 8,
            border: '1px solid #ddd',
            marginBottom: 16,
          }}
        >
          <option value="">Select yes or no</option>
          <option value="yes">Yes</option>
          <option value="no">No</option>
          <option value="not_applicable">Not applicable</option>
        </select>

        <label style={{ display: 'block', marginBottom: 4 }}>
          Estimated marginal federal tax bracket (pick one)
        </label>
        <select
          value={marginalRate}
          onChange={(e) => setMarginalRate(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: 8,
            border: '1px solid #ddd',
            marginBottom: 16,
          }}
        >
          <option value="">Select your bracket</option>
          <option value="0.10">10%</option>
          <option value="0.12">12%</option>
          <option value="0.22">22%</option>
          <option value="0.24">24%</option>
          <option value="0.32">32%</option>
          <option value="0.35">35%</option>
          <option value="0.37">37%</option>
        </select>

        <label style={{ display: 'block', marginBottom: 4 }}>
          Your Question
        </label>
        <input
          type="text"
          value={userMessage}
          onChange={(e) => setUserMessage(e.target.value)}
          placeholder="Type your question here..."
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: 8,
            border: '1px solid #ddd',
            marginBottom: 12,
          }}
        />

        <button
          type="submit"
          style={{
            padding: '10px 16px',
            borderRadius: 8,
            border: 'none',
            backgroundColor: '#2563eb',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Calculate tax savings
        </button>
      </form>

      {chatReply && (
        <div
          style={{
            border: '1px solid #ddd',
            borderRadius: 8,
            padding: 12,
            marginTop: 16,
            background: '#e8f5e9',
          }}
        >
          <h3>Chatbot Reply</h3>
          <p style={{ whiteSpace: 'pre-wrap' }}>{chatReply}</p>
        </div>
      )}

      {!summary && !explanation && !loading && !error && !chatReply && (
        <p style={{ color: '#666', marginTop: 8 }}>
          Click Calculate to see the client's expected tax savings.
        </p>
      )}
    </div>
  );
}

export default ChatAgent;
